module.exports = __webpack_public_path__ + "static/media/p21.c9b2b808.png";